/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// structure
import Division from 'material/structure/division/division';
import Subhead from 'material/structure/subhead/subhead';
// pages
import EmbedManagement from 'pages/dashboard/embeds/management/embed_management_container';
import EmbedAnalytics from 'pages/dashboard/embeds/analytics/embed_analytics_container';
import LibraryPage from 'pages/dashboard/embeds/library/library_container';
// material
import CTAs from 'material/ctas/ctas';
import EditEmbedCTA from 'material/ctas/editembed/editembed_container';
import AnalyticsCTA from 'material/ctas/analytics/analytics_container';
import PervasiveMessage from 'material/message/pervasivemessage/pervasivemessage_container';
// utils
import { Route, Switch, Redirect } from 'react-router';
import { PrivateRoute } from 'utils/privateRoute';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/embeds_styles';



/* ========== ~~~~~~~~~~ EMBEDS SECTION : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class Embeds extends Component {
    componentDidMount() {
        if (!this.props.isDataReceived) this.props.getClientEmbedsData(this.props.accountUUID);
    }
    isLibraryPage = () => this.props.currentPage === 'dashboard/embeds';
    isAnalyticsPage = () => this.props.currentPage.includes('embedcontent');
    isCustomizePage = () => !this.isAnalyticsPage() && !this.isLibraryPage() && this.props.currentPage !== 'dashboard/embeds/management/code';
    handleEmbedName = () => this.isLibraryPage() ? null : this.props.embedName ? <span className={`uniquename embedname`}>{`/ ${this.props.embedName}`}</span> : null;
    handleCTAs = () => {
        return this.isLibraryPage() ? null :
            <CTAs>
                {this.isAnalyticsPage() && this.props.editPermitted && !!this.props.embedUUID ? <EditEmbedCTA /> : null}
                {this.isCustomizePage() && !!this.props.embedUUID ? <AnalyticsCTA /> : null}
            </CTAs>
        ;
    }
    render() {
        if(!this.props.permissionsReceived) return null;
        return(
            <Division name={`embeds`} klass={this.props.classes.embeds}>
                <Subhead>
                    <h1 className = {'embedheadername'}>Embeds {this.handleEmbedName()}</h1>
                    {this.handleCTAs()}
                </Subhead>
                <PervasiveMessage padding={15}/>
                <Switch>
                    {/*Routes to subsections*/}
                    <Route exact path='/dashboard/embeds' component={LibraryPage} />
                    <Route path='/dashboard/embeds/analytics' component={EmbedAnalytics} />
                    <PrivateRoute permitted={this.props.editPermitted} path='/dashboard/embeds/management' component={EmbedManagement} />
                    <Redirect to='/error/404' />
                </Switch>
            </Division>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(Embeds);